<template>
  <div class="loaderWrapper">
    <pulse-loader
      :loading="showLoader"
      :color="siteSettings.accent"
      size="25px"
    ></pulse-loader>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
export default {
  name: "Loader",
  components: {
    PulseLoader
  },
  props: {
    showLoader: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(["siteSettings"])
  }
};
</script>

<style lang="scss">
.loaderWrapper {
  // causing issue with views
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // top: calc(50% - 12.5px);
  // left: calc(50% - 50px);
  // width: 100px;
  // height:200px;
  // z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
